(() => {
  const checkoutSelector = '#checkout, #CartDrawer-Checkout';
  const nativeSubmit = HTMLFormElement.prototype.submit;
  let submitting = false;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest(checkoutSelector);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const form = button.form || document.getElementById(button.getAttribute('form') || '');
    if (!(form instanceof HTMLFormElement) || submitting) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    submitting = true;
    button.setAttribute('aria-busy', 'true');
    button.dataset.bpcCheckoutSubmitting = 'true';

    let checkoutInput = form.querySelector('input[data-bpc-checkout-fallback][name="checkout"]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      checkoutInput.dataset.bpcCheckoutFallback = 'true';
      form.appendChild(checkoutInput);
    }

    nativeSubmit.call(form);
  }, true);
})();
